/**
 * Loader component.
 */

const Loader = ( props ) => {
	return (
		<div className="c-search__loader">
			<div className="lds-facebook">
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	)
}

export default Loader;
